var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFfJoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7282 14.2857H16.9612V11.5714C16.9612 11.4929 16.9 11.4286 16.8252 11.4286H12.6117V9.71429H14.4466C14.5961 9.71429 14.7184 9.58571 14.7184 9.42857V4.28571C14.7184 4.12857 14.5961 4 14.4466 4H9.5534C9.40388 4 9.28155 4.12857 9.28155 4.28571V9.42857C9.28155 9.58571 9.40388 9.71429 9.5534 9.71429H11.3883V11.4286H7.17476C7.1 11.4286 7.03883 11.4929 7.03883 11.5714V14.2857H5.27184C5.12233 14.2857 5 14.4143 5 14.5714V19.7143C5 19.8714 5.12233 20 5.27184 20H10.165C10.3146 20 10.4369 19.8714 10.4369 19.7143V14.5714C10.4369 14.4143 10.3146 14.2857 10.165 14.2857H8.26214V12.7143H15.7379V14.2857H13.835C13.6854 14.2857 13.5631 14.4143 13.5631 14.5714V19.7143C13.5631 19.8714 13.6854 20 13.835 20H18.7282C18.8777 20 19 19.8714 19 19.7143V14.5714C19 14.4143 18.8777 14.2857 18.7282 14.2857ZM9.14563 15.6429V18.6429H6.29126V15.6429H9.14563ZM10.5728 8.35714V5.35714H13.4272V8.35714H10.5728ZM17.7087 18.6429H14.8544V15.6429H17.7087V18.6429Z",
    fill: "#240b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfJoints);
export default __webpack_public_path__ + "static/media/ff-joints.f1db1d703fcb86419aaf1539f267c3f4.svg";
export { ForwardRef as ReactComponent };